import { Color, setColor } from 'app_previous/styles/colors';
import styled from 'styled-components';

export interface LoadingDotsColorProps {
  background?: Color;
  loadingDotColor?: Color;
}

export const LoadingContainer = styled.div<LoadingDotsColorProps>`
  width: 78px;
  height: 43px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  background-color: ${({ background }) => setColor(background)};
  border-radius: 24px;

  div:nth-child(2) {
    animation-delay: 300ms;
  }
  div:nth-child(3) {
    animation-delay: 600ms;
  }
`;

export const LoadingDot = styled.div<LoadingDotsColorProps>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${({ loadingDotColor }) => setColor(loadingDotColor)};
  animation: bounce 1.2s infinite ease-in-out;

  & + & {
    margin-left: 7px;
  }

  @keyframes bounce {
    0% {
      transform: translateY(0px);
      opacity: 1;
    }
    25% {
      transform: translateY(-4px);
      opacity: 0.5;
    }
    50% {
      transform: translateY(0px);
      opacity: 1;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
`;
